module.exports = __webpack_public_path__ + "assets/img/sabc_contact_drop_arrow.webp?f9d281dab1992152e338343c2132f5f8";